/* eslint-disable indent */
import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Typography, ListItem, ListItemButton, ListItemIcon, ListItemText, Toolbar, Drawer, Box } from '@mui/material';

import { DashboardPages } from 'constants/ui.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import BrandLogo from 'assets/images/BrandLogo';
import { CustomList, DrawerHeader } from '../../theme/layouts/sidebar';
import { palette } from '../../theme/palette';
import EnvStatus from 'components/EnvStatus';

const DashboardSidebar: React.FC = () => {
  const navigate = useNavigate();
  const { serverVersion } = useAppSelector((state) => state.global);
  const location = useLocation();

  const selectedPageNameFormat = (selectedPageName: string): string => {
    return selectedPageName === 'sites'
      ? 'Sites'
      : selectedPageName === 'users-and-permission'
      ? 'Users and permission'
      : selectedPageName === 'cp'
      ? 'CP'
      : selectedPageName === 'patients'
      ? 'Patients'
      : selectedPageName === 'audit'
      ? 'Audit'
      : '';
  };

  const isSelected = (link: string): boolean => {
    return !!location.pathname.match('^' + link);
  };

  const drawerWidth = 316;
  return (
    <Drawer
      variant='permanent'
      sx={{
        width: drawerWidth,
        height: 1,
        flexShrink: 0,
        ['& .MuiDrawer-paper']: { width: drawerWidth, boxSizing: 'border-box', position: 'unset' }
      }}
    >
      <DrawerHeader>
        <BrandLogo width={'90px'} height={'50px'} />
        <EnvStatus fontSize={'12px'} />
      </DrawerHeader>

      <Box sx={{flex: 1, display: 'flex', flexDirection: 'column'}}>
        {DashboardPages.map((page, index) => (
          <CustomList key={index} disablePadding>
            <ListItem
              disablePadding
              className={isSelected(page.link) ? 'selected' : ''}
              sx={{
                borderRadius: '8px',
                '& .MuiListItemButton-root:hover': {
                  borderRadius: '8px'
                }
              }}
            >
              <ListItemButton
                data-testid='tab-button'
                onClick={() => {
                  navigate(page.link);
                }}
              >
                <ListItemIcon>
                  {isSelected(page.link) ? <page.selectedIcon hover={true} /> : <page.icon hover={true} />}
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: isSelected(page.link) ? palette.root.profileSecondary : palette.root.profile
                  }}
                  primary={selectedPageNameFormat(page.name)}
                />
              </ListItemButton>
            </ListItem>
          </CustomList>
        ))}
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end'}}>
          <Typography
            sx={{ paddingInline: '24px', paddingBlock: '12px', fontSize: '12px', color: palette.root.textBorder }}
          >
            App Version {process.env.VERSION}
          </Typography>
          <Typography
            sx={{ paddingInline: '24px', paddingBottom: '24px', fontSize: '12px', color: palette.root.textBorder }}
          >
            Server Version {serverVersion}
          </Typography>
        </Box>
      </Box>
    </Drawer>
  );
};
export default DashboardSidebar;
